import { render, staticRenderFns } from "./DialogEditMail.vue?vue&type=template&id=405fab6e&scoped=true"
import script from "./DialogEditMail.vue?vue&type=script&lang=js"
export * from "./DialogEditMail.vue?vue&type=script&lang=js"
import style0 from "./DialogEditMail.vue?vue&type=style&index=0&id=405fab6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405fab6e",
  null
  
)

export default component.exports